import { formatLastUpdatedDate } from '../../../utils/date-utils';
import { useGetHealthData } from '../../../use-health-data';
import { LastUpdatedTagSkeleton } from './last-updated-tag-skeleton';

export function LastUpdatedTag() {
  const { healthData, isInitiallyFetching } = useGetHealthData();
  const lastUpdatedDate = healthData?.metadata?.lastUpdated;

  if (isInitiallyFetching) {
    return <LastUpdatedTagSkeleton />;
  }

  if (!lastUpdatedDate) {
    return null;
  }

  return (
    <div className="flex justify-center">
      <div className="bg-white/10 rounded-full px-3 py-0.5">
        <span className="text-white text-xs font-bold">
          Last Updated {formatLastUpdatedDate(lastUpdatedDate)}
        </span>
      </div>
    </div>
  );
}
